<template>
  <div id="app">
    <T1HeadScripts />
    <a-layout id="components-layout-demo-top" class="layout">
      <T1Header />
      <T1GeoPrzewodnikContent />
      <T1Footer />
    </a-layout>
  </div>
</template>

<script>
import T1HeadScripts from "./components/T1HeadScripts";
import T1Header from "./components/T1Header/T1Header";
import T1GeoPrzewodnikContent from "./components/T1GeoPrzewodnikContent";
import T1Footer from "./components/T1Footer/T1Footer";

export default {
  name: "app",
  components: {
    T1HeadScripts,
    T1Header,
    T1GeoPrzewodnikContent,
    T1Footer
  }
};
</script>
